<template>
  <div class="b-block b-block--transparent b-block--sm-pad">
    <div class="b-block__form-section">
      <!-- firstName -->
      <div class="form-floating">
        <input
          id="firstName"
          v-model="firstName"
          type="text"
          class="form-control"
          :placeholder="dictionary.firstNameLabel"
          :class="{ 'form-control--error': v$.firstName.$error }"
          @blur="v$.firstName.$touch" />
        <label for="firstName">{{ dictionary.firstNameLabel }}</label>
        <div v-if="v$.firstName.$error">
          <div
            v-if="v$.firstName.required.$invalid"
            class="field-validation-error">
            {{ dictionary.firstNameRequired }}
          </div>
          <div
            v-if="
              v$.firstName.minLength.$invalid || v$.firstName.maxLength.$invalid
            "
            class="field-validation-error">
            {{ dictionary.firstNameLength }}
          </div>
          <div
            v-if="v$.firstName.regex.$invalid"
            class="field-validation-error">
            {{ dictionary.firstNameRegex }}
          </div>
        </div>
      </div>

      <!-- lastName -->
      <div class="form-floating">
        <input
          id="lastName"
          v-model="lastName"
          type="text"
          class="form-control"
          :placeholder="dictionary.lastNameLabel"
          :class="{ 'form-control--error': v$.lastName.$error }"
          @blur="v$.lastName.$touch" />
        <label for="lastName">{{ dictionary.lastNameLabel }}</label>
        <div v-if="v$.lastName.$error">
          <div
            v-if="v$.lastName.required.$invalid"
            class="field-validation-error">
            {{ dictionary.lastNameRequired }}
          </div>
          <div
            v-if="
              v$.lastName.minLength.$invalid || v$.lastName.maxLength.$invalid
            "
            class="field-validation-error">
            {{ dictionary.lastNameLength }}
          </div>
          <div v-if="v$.lastName.regex.$invalid" class="field-validation-error">
            {{ dictionary.lastNameRegex }}
          </div>
        </div>
      </div>

      <!-- email -->
      <div class="form-floating">
        <input
          id="email"
          v-model="email"
          type="email"
          class="form-control"
          :placeholder="dictionary.emailLabel"
          :class="{ 'form-control--error': v$.email.$error }"
          @blur="v$.email.$touch" />
        <label for="lastNameLabel">{{ dictionary.emailLabel }}</label>
        <div v-if="v$.email.$error">
          <div v-if="v$.email.required.$invalid" class="field-validation-error">
            {{ dictionary.emailRequired }}
          </div>
          <div v-if="v$.email.email.$invalid" class="field-validation-error">
            {{ dictionary.emailRegex }}
          </div>
        </div>
      </div>

      <!-- mobilePhone -->
      <div class="form-floating">
        <input
          id="mobilePhone"
          v-model="mobilePhone"
          type="text"
          class="form-control"
          :placeholder="dictionary.mobilePhoneLabel"
          :class="{ 'form-control--error': v$.mobilePhone.$error }"
          @blur="v$.mobilePhone.$touch" />
        <label for="mobilePhone">{{ dictionary.mobilePhoneLabel }}</label>
        <div v-if="v$.mobilePhone.$error">
          <div
            v-if="v$.mobilePhone.required.$invalid"
            class="field-validation-error">
            {{ dictionary.mobilePhoneRequired }}
          </div>
          <div
            v-if="v$.mobilePhone.regex.$invalid"
            class="field-validation-error">
            {{ dictionary.mobilePhoneRegex }}
          </div>
        </div>
      </div>
    </div>
    <div class="p-contact__form-message">
      {{ dictionary.requiredInputs }}
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import constants from '../../../../lib/constants'
import {
  email,
  helpers,
  maxLength,
  minLength,
  required,
} from '@vuelidate/validators'
import { useBookingStore } from './../../../store/BookingStore'

const { telephone, greekLatinSpace } = constants.regex

export default {
  props: {
    additionalPayload: {
      default() {
        return null
      },
      type: Object,
    },
  },
  emits: ['change-input'],
  setup() {
    return { store: useBookingStore(), v$: useVuelidate() }
  },
  validations() {
    return {
      firstName: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(40),
        regex: helpers.regex(greekLatinSpace),
      },
      lastName: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(40),
        regex: helpers.regex(greekLatinSpace),
      },
      email: {
        required,
        email,
      },
      mobilePhone: {
        required,
        regex: helpers.regex(telephone),
      },
    }
  },
  computed: {
    firstName: {
      get: function () {
        return this.store.bookingProgress.paymentDetails.firstName
      },
      set: function (value) {
        this.store.setPaymentField({ field: 'firstName', value })
        this.$emit('change-input')
      },
    },

    lastName: {
      get: function () {
        return this.store.bookingProgress.paymentDetails.lastName
      },
      set: function (value) {
        this.store.setPaymentField({ field: 'lastName', value })
        this.$emit('change-input')
      },
    },

    email: {
      get: function () {
        return this.store.bookingProgress.paymentDetails.email
      },
      set: function (value) {
        this.store.setPaymentField({ field: 'email', value })
        this.$emit('change-input')
      },
    },

    mobilePhone: {
      get: function () {
        return this.store.bookingProgress.paymentDetails.mobilePhone
      },
      set: function (value) {
        this.store.setPaymentField({ field: 'mobilePhone', value })
        this.$emit('change-input')
      },
    },
  },
  mounted() {
    if (this.store.userIsLoggedIn && this.store.accountIsInValidForPayment) {
      this.v$.$validate()
    }
  },
}
</script>
